function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuilding = function SvgBuilding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.2 1H4.8C3.8 1 3 1.8 3 2.8v14.5c0 1 .8 1.8 1.8 1.8H8v-3.2c0-.5.4-.9.8-.9h2.4c.4 0 .8.4.8.8V19h3.2c1 0 1.8-.8 1.8-1.8V2.8c0-1-.8-1.8-1.8-1.8zm-2.1 12H6.9c-.6 0-1-.4-1-1s.4-1 1-1h6.2c.6 0 1 .4 1 1s-.4 1-1 1zm0-4H6.9c-.6 0-1-.4-1-1s.4-1 1-1h6.2c.6 0 1 .4 1 1s-.4 1-1 1zm0-4H6.9c-.6 0-1-.4-1-1s.4-1 1-1h6.2c.6 0 1 .4 1 1s-.4 1-1 1z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgBuilding;